module.exports = __webpack_public_path__ + "static/media/Сборник тезисов. Часть 1.cc60db94.pdf";